<template>
	<div>
		<div :class="getClasses" style="white-space: normal; display: inline-block; height: auto; width: auto; padding: 0.25em 0.75em;">
			<slot/>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		error: {
			type: Boolean,
			default: false
		},

		success: {
			type: Boolean,
			default: false
		},

		warning: {
			type: Boolean,
			default: false
		},

		info: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		getClasses() {
			return [
				'tag',
				'is-normal',
				'is-light',
				{
					'is-danger': this.error,
					'is-success': this.success,
					'is-warning': this.warning,
					'is-info': this.info
				}
			];
		}
	}
};
</script>
